<template>
  <EditCom
    title="服务发布"
    :target="target"
    :buttonList="buttonList"
    :inputList="inputList"
    :rules="rules"
    @closeFun="close"
  ></EditCom>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';

import EditCom from '@/components/EditCom';
import { queryOrdinaryUserList } from '@/api/System/UserManager';

import {
  publishFootPrintMap,
} from '@/api/UserWorkspaceApi';
// props
const props = defineProps({
  target: { type: Object, },
});
// emit
const emit = defineEmits([
  'close',
]);

const close = ()=>{
  emit('close');
}

const target = ref({
  ...props.target,
  geoserverWorkspaceName: 'basemap',
  layerTypeList: [ '侦察足迹', '预警足迹' ],
  timeTypeList: [
    { label: '周', value: 1 },
    { label: '月', value: 2 },
    { label: '季度', value: 3 },
    { label: '年', value: 4 },
  ],

});

const submitFn = (item, button, loadFn, fn)=>{
  const data = {
    // ...item,
    workspaceId: item['id'],
    layerDataStartDate: dayjs(item['layerDataStartDate']).format('YYYY-MM-DD'),
    layerDataEndDate: dayjs(item['layerDataEndDate']).format('YYYY-MM-DD'),
    layerName: item['layerName'],
    timeType: item['timeType'],
    layerType: item['layerType'],
    geoserverWorkspaceName: item['geoserverWorkspaceName'],
    tileEffectiveTime: item['tileEffectiveTime']?dayjs(item['tileEffectiveTime']).format('YYYY-MM-DD HH:mm:ss'):undefined,
    userIds: item['userIds']
    // geoserverWorkspaceName: item['geoserverWorkspaceName'],
  }
  publishFootPrintMap(data).then(res=>{
    if(res.data.code == 1004){
      close();
    }
    loadFn && loadFn();
  }).catch(err=>{
    loadFn && loadFn();
    message('操作异常', 2);
    console.log(err);
  });
}
const submit = (form, item, button, loadFn, fn)=>{
  // console.log(form, item, button, loadFn, fn);
  form.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      submitFn(item, button, loadFn, fn);
    }else{
      loadFn && loadFn();
    }
  });
};
const queryOrdinaryUserListFn = ()=>{
  queryOrdinaryUserList({}).then(res=>{
    if(res.data.code == 1004){
      target.value['userList'] = res['data']['dataList'];
    }
  }).catch(err=>{
    console.log(err);
  });
}

const buttonList = ref([
  { name: '取消', fun: close, type: 'danger', },
  { name: '确定', fun: submit, type: 'primary', },
]);
const inputList = ref([
  { name: '图层名称', prop: 'layerName', type: 'text' },
  // { name: '快照名称(geoserver)', prop: 'geoserverWorkspaceName', type: 'text' },
  { name: '图层类型', prop: 'layerType', type: 'select',
    select: {
      list: 'layerTypeList',
      value: 'this',
    }
  },
  { name: '图层时间类型', prop: 'timeType', type: 'select',
    select: {
      list: 'timeTypeList',
      label: 'label',
      value: 'value',
    }
  },
  { name: '图层涉及数据开始日期', prop: 'layerDataStartDate', type: 'date',
    date: {}
  },
  { name: '图层涉及数据结束日期', prop: 'layerDataEndDate', type: 'date',
    date: {}
  },
  { name: '用户', prop: 'userIds', type: 'select',
    select: {
      list: 'userList',
      label: 'userName',
      value: 'userId',
      multiple: true,
      filterable: true,
    }
  },
  { name: '用户使用有效期', prop: 'tileEffectiveTime', type: 'datetime', date: {}, },
]);
const rules = reactive({
  layerName: [
    { required: true, message: '请输入图层名称', trigger: 'blur' },
    { 
      // pattern: /^[a-zA-Z0-9]+$/, // 正则表示只能包含字母和数字
      pattern: /^[a-zA-Z0-9_-]+$/, // 正则表示只能包含字母和数字
      message: '名称只能包含字母、数字、-、_',
      trigger: 'blur' // 通常在 'blur' 事件触发校验
    }
  ],
  geoserverWorkspaceName: [
    { required: true, message: '请输入快照名称', trigger: 'blur' },
  ],
  layerType: [
    { required: true, message: '请选择图层类型', trigger: 'blur' },
  ],
  timeType: [
    { required: true, message: '请选择图层时间类型', trigger: 'blur' },
  ],
  layerDataStartDate: [
    { required: true, message: '请选择图层涉及数据开始日期', trigger: 'blur' },
  ],
  layerDataEndDate: [
    { required: true, message: '请选择图层涉及数据结束日期', trigger: 'blur' },
  ],
});

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  queryOrdinaryUserListFn();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>